import { FirebaseDocRefType } from 'firebase/index'
import { StoreDeliveryBreadType } from 'types/storeDeliveryBread'

export const fetchStoreDeliveryBread = (ref: FirebaseDocRefType): Promise<StoreDeliveryBreadType | undefined> => {
  return ref
    .get()
    .then((snapshot) => {
      if (!snapshot.exists) return undefined
      const data = snapshot.data() as StoreDeliveryBreadType
      data.ref = snapshot.ref
      return data
    })
    .catch((error) => {
      console.error(error)
      return undefined
    })
}

export const fetchStoreDeliveryBreads = (storeRef: FirebaseDocRefType): Promise<StoreDeliveryBreadType[]> => {
  return storeRef
    .collection('store_delivery_breads')
    .orderBy('bread_ref', 'asc')
    .get()
    .then((snapshots) => {
      return snapshots.docs.map((snapshot) => {
        const data = snapshot.data() as StoreDeliveryBreadType
        data.ref = snapshot.ref
        return data
      })
    })
    .catch((error) => {
      console.error(error)
      return []
    })
}
